import "login-react-ccs/dist/index.css";

import React from "react";
import { Login } from "login-react-ccs";

import logoImage from "../assets/imgs/login-logo-image.png";
import backgroundImage from "../assets/imgs/bg-whatsapp.jpg";

const LazyApplication = (): JSX.Element => {
    const handleOnOpenExternal = (url: string) => window.open(url, "_blank");

    return (
        <Login
            canChangeLanguage={false}
            isLoading={true}
            hasEffect={false}
            colorLoadingBars="var(--login-primary-color)"
            backgroundImage={backgroundImage}
            onOpenExternal={handleOnOpenExternal}
            logo={{
                image: logoImage,
                width: 200,
                height: 120,
            }}
        />
    );
};

export default LazyApplication;
